import img from "../../assets/images/logo-light.png";
import { useNavigate } from "react-router-dom";
import BaseButton from "Components/Base/BaseButton";

const Forbidden = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="forbidden-page overflow-hidden d-flex flex-column justify-content-center align-items-center vh-100 text-center">
      <h1 className="display-1 fw-bold">403</h1>
      <h4 className="fw-bold">Access Denied</h4>
      <p className="text-muted w-50">
        Your current role does not grant access to this section. Please contact
        your administrator for more information.
      </p>
      <BaseButton className="mt-3" color="success" onClick={handleBack}>
        Go Back
      </BaseButton>
    </div>
  );
};

export default Forbidden;
